<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'productivity-settings-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowDblClick)="onRowDblClick($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-editing
                [mode]="'row'"
                [allowUpdating]="true"
                [allowAdding]="true"
                [allowDeleting]="true"
                [useIcons]="true"
            >
            </dxo-editing>
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>
            
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Productivity Settings</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" 
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button class="ms-sm-2" text="New" icon="plus" type="default" stylingMode="contained" (onClick)="addNew()"></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column
                [dataField]="gridFieldName('value')"
                caption="Value"
                cellTemplate="number"
                alignment="left"
                [minWidth]="20"
                [editorOptions]="{ min: 0, step: 0.01, format: { type: 'fixedPoint', precision: 2 } }"
            >
                <dxi-validation-rule type="required" message="Percentage is required"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="0" message="Must be greater than or equal to 0"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('month')" caption="Month" cellTemplate="month" [lookup]="{ dataSource: monthOptions, valueExpr: 'value', displayExpr: 'text' }"
                [filterOperations]="['=']" [headerFilter]="{ dataSource: monthOptions }" [minWidth]="50" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('year')"
                caption="Year"
                alignment="left"
                [minWidth]="20"
                [editorOptions]="{ min: minYear, max: maxYear }"
                [sortIndex]="0" 
                [sortOrder]="'desc'"
            >
                <dxi-validation-rule type="required" message="Year is required"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="minYear" [max]="maxYear" [message]="'Must be between ' + minYear + ' and ' + maxYear"></dxi-validation-rule>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Created" cellTemplate="created" [minWidth]="50" [visible]="false" [sortOrder]="'desc'"></dxi-column>

            <div *dxTemplate="let cellInfo of 'number'">
                {{ getCellData(cellInfo).value | number:'1.2-2' }}
            </div>
            <div *dxTemplate="let cellInfo of 'month'">
                {{ getCellData(cellInfo).month | capitalCase }}
            </div>
            <div *dxTemplate="let cellInfo of 'created'">                
                {{ getCellData(cellInfo).created | date:dateTimeFormat }}
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('value')" editorType="dxNumberBox" [editorOptions]="{placeholder: 'Percentage', stylingMode: 'filled'}"></dxi-item>   
            <dxi-item [dataField]="filterModelName('month')" editorType="dxSelectBox" [editorOptions]="{ items: monthOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Month', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('year')" editorType="dxNumberBox" [editorOptions]="{placeholder: 'Year', stylingMode: 'filled'}"></dxi-item>  
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }" ></dxi-item>
        </dx-form>
    </filter-panel>
</div>
